// extracted by mini-css-extract-plugin
module.exports = {"accounts":"_3kv5t","label":"qK0xi","icon":"_9F04l","surface":"V1CKO","select":"G0BV6","selectBtn":"jc94I","list":"qc4TI","row":"Q3qKe","actions":"ATNa7","midContent":"kI-zM"};